import { render } from "./AddFlowModal.vue?vue&type=template&id=20f4d572"
import script from "./AddFlowModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddFlowModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/AddFlowModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20f4d572"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20f4d572', __exports__)) {
    api.reload('20f4d572', __exports__)
  }
  
  module.hot.accept("./AddFlowModal.vue?vue&type=template&id=20f4d572", () => {
    api.rerender('20f4d572', render)
  })

}


export default __exports__